// import React, { useState, useEffect } from 'react';
// import './Mymatches.css';
// import { useProfile } from '../context/ProfileContext';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';

// const Mymatches = () => {
//   const [activeTab, setActiveTab] = useState('Upcoming');
//   const { profile } = useProfile();
//   const navigate = useNavigate();
//   const [matches, setMatches] = useState({
//     upcoming: [],
//     live: [],
//     completed: []
//   });
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);


//   const tabs = ['Upcoming', 'Live', 'Completed'];
//   const userId=profile.userId;
//   // Fetch matches from API
//   useEffect(() => {
//     const fetchMatches = async () => {
//       try {
//         setLoading(true);
//         console.log('Fetching matches for user ID:', userId);
//         const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/matches/${userId}`);
//         console.log('Fetched matches:', response.data);
//         setMatches(response.data);
//         setLoading(false);
//       } catch (err) {
//         console.error('Error fetching matches:', err);
//         setError('Failed to load matches. Please try again later.');
//         setLoading(false);
//       }
//     };
  
//     if (userId) {
//       fetchMatches();
//     }
//   }, [userId]);
  

//   const handleTabClick = (tab) => {
//     setActiveTab(tab);
//   };

//   const handleMatchClick = (matchId) => {
//     // Go directly to match detail regardless of status
//     console.log('Navigating to match detail for ID:', matchId);
//     navigate(`/match-detail/${matchId}`);
//   };
  
//   console.log(matches)

//   const getBadgeClass = (status) => {
//     if (status === 'live') return 'badge-live';
//     if (status === 'upcoming' || status === 'upcomming') return 'badge-upcoming';
//     if (status === 'completed' || status === 'complete') return 'badge-completed';
//     return '';
//   };

//   const renderMatchesList = () => {
//     if (loading) {
//       return <div className="mymatches-loading">Loading matches...</div>;
//     }

//     if (error) {
//       return <div className="mymatches-error">{error}</div>;
//     }

//     const activeMatches = matches[activeTab.toLowerCase()];
    
//     if (!activeMatches || activeMatches.length === 0) {
//       return (
//         <div className="mymatches-no-matches">
//           <p>No {activeTab.toLowerCase()} matches</p>
//         </div>
//       );
//     }

//     return activeMatches.map((match, index) => (
//       <div 
//         className="mymatches-card" 
//         key={index} 
//         onClick={() => handleMatchClick(match.id)}
//       >
//         <div className="mymatches-match">
//           <div className="mymatches-team mymatches-team-left">
//             {match.team1}
//           </div>
//           <div className="mymatches-score-container">
//             <div className="mymatches-score">
//               {match.score}
//               <div className="mymatches-time">{match.time}</div>
//             </div>
//           </div>
//           <div className="mymatches-team mymatches-team-right">
//             {match.team2}
//           </div>
//           <div className={`mymatches-live-badge ${getBadgeClass(match.status)}`}>
//             {match.status}
//           </div>
//         </div>
//         <div className="mymatches-joined-info">
//           <span>{match.contestsJoined} Questions • ₹{match.amount} • {match.betType}</span>
//           {match.profit > 0 && <span className="mymatches-profit">Win/Loss: ₹{match.profit}</span>}
//         </div>
//       </div>
//     ));
//   };

//   return (
//     <div className="mymatches-page">
//       {/* Header Section */}
//       <header className="header">
//         <div className="header-left">
//           <h1 className="site-title"  onClick={() => navigate('/')}>CricWhizz</h1>
//         </div>
//         <div className="header-right">
//           <div className="wallet-button">
//             <span className="wallet-icon">💰</span>
//             <span className="wallet-amount">{profile.walletBalance}$</span>
//           </div>
//           {/* <button className="logout-button">
//             <span role="img" aria-label="credit-card">💳</span>
//           </button> */}
//         </div>
//       </header>

//       {/* Main Content */}
//       <div className="mymatches-content">
//         <div className="mymatches-container">
//           <div className="mymatches-tabs">
//             {tabs.map((tab) => (
//               <button
//                 key={tab}
//                 className={`mymatches-tab ${activeTab === tab ? 'mymatches-tab-active' : ''}`}
//                 onClick={() => handleTabClick(tab)}
//               >
//                 {tab}
//               </button>
//             ))}
//           </div>

//           <div className="mymatches-list">
//             {renderMatchesList()}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Mymatches;



import React, { useState, useEffect } from 'react';
import './Mymatches.css';
import { useProfile } from '../context/ProfileContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Mymatches = () => {
  const [activeTab, setActiveTab] = useState('Upcoming');
  const { profile } = useProfile();
  const navigate = useNavigate();
  const [matches, setMatches] = useState({
    upcoming: [],
    live: [],
    completed: []
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  const tabs = ['Upcoming', 'Live', 'Completed'];
  const userId=profile.userId;
  // Fetch matches from API
  useEffect(() => {
    const fetchMatches = async () => {
      try {
        setLoading(true);
        console.log('Fetching matches for user ID:', userId);
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/matches/${userId}`);
        console.log('Fetched matches:', response.data);
        setMatches(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching matches:', err);
        setError('Failed to load matches. Please try again later.');
        setLoading(false);
      }
    };
  
    if (userId) {
      fetchMatches();
    }
  }, [userId]);
  

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleMatchClick = (matchId, betType = null) => {
    // Navigate based on bet type if provided, otherwise go to general match detail
    if (betType === '4Ka100') {
      console.log('Navigating to 4Ka100 for match ID:', matchId);
      navigate(`/match-detail/${matchId}/4ka100`);
    } else if (betType === 'Parley') {
      console.log('Navigating to Parley for match ID:', matchId);
      navigate(`/match-detail/${matchId}/parley`);
    } else {
      console.log('Navigating to match detail for ID:', matchId);
      navigate(`/match-detail/${matchId}`);
    }
  };
  
  console.log(matches)

  const getBadgeClass = (status) => {
    if (status === 'live') return 'badge-live';
    if (status === 'upcoming' || status === 'upcomming') return 'badge-upcoming';
    if (status === 'completed' || status === 'complete') return 'badge-completed';
    return '';
  };

  const renderMatchesList = () => {
    if (loading) {
      return <div className="mymatches-loading">Loading matches...</div>;
    }

    if (error) {
      return <div className="mymatches-error">{error}</div>;
    }

    const activeMatches = matches[activeTab.toLowerCase()];
    
    if (!activeMatches || activeMatches.length === 0) {
      return (
        <div className="mymatches-no-matches">
          <p>No {activeTab.toLowerCase()} matches</p>
        </div>
      );
    }

    // Group matches by matchId to show unique matches only
    const uniqueMatches = activeMatches.reduce((acc, match) => {
      if (!acc[match.matchId]) {
        acc[match.matchId] = match;
      }
      return acc;
    }, {});

    const uniqueMatchesArray = Object.values(uniqueMatches);

    return uniqueMatchesArray.map((match, index) => (
      <div 
        className="mymatches-card" 
        key={match.matchId}
      >
        <div className="mymatches-match">
          <div className="mymatches-team mymatches-team-left">
            {match.team1}
          </div>
          <div className="mymatches-score-container">
            <div className="mymatches-score">
              {match.score}
              <div className="mymatches-time">{match.time}</div>
            </div>
          </div>
          <div className="mymatches-team mymatches-team-right">
            {match.team2}
          </div>
          <div className={`mymatches-live-badge ${getBadgeClass(match.status)}`}>
            {match.status}
          </div>
        </div>
        {/* <div className="mymatches-joined-info">
          <span>{match.contestsJoined} Questions • ₹{match.amount} • {match.betType}</span>
          {match.profit > 0 && <span className="mymatches-profit">Win/Loss: ₹{match.profit}</span>}
        </div> */}
        <div className="mymatches-buttons">
          <button 
            className="mymatches-bet-button mymatches-4ka100-button"
            onClick={(e) => {
              e.stopPropagation();
              handleMatchClick(match.matchId, '4Ka100');
            }}
          >
            4Ka100
          </button>
          <button 
            className="mymatches-bet-button mymatches-parley-button"
            onClick={(e) => {
              e.stopPropagation();
              handleMatchClick(match.matchId, 'Parley');
            }}
          >
            Parley
          </button>
        </div>
      </div>
    ));
  };

  return (
    <div className="mymatches-page">
      {/* Header Section */}
      <header className="header">
        <div className="header-left">
          <h1 className="site-title"  onClick={() => navigate('/')}>CricWhizz</h1>
        </div>
        <div className="header-right">
          <div className="wallet-button">
            <span className="wallet-icon">💰</span>
            <span className="wallet-amount">{profile.walletBalance}</span>
          </div>
          {/* <button className="logout-button">
            <span role="img" aria-label="credit-card">💳</span>
          </button> */}
        </div>
      </header>

      {/* Main Content */}
      <div className="mymatches-content">
        <div className="mymatches-container">
          <div className="mymatches-tabs">
            {tabs.map((tab) => (
              <button
                key={tab}
                className={`mymatches-tab ${activeTab === tab ? 'mymatches-tab-active' : ''}`}
                onClick={() => handleTabClick(tab)}
              >
                {tab}
              </button>
            ))}
          </div>

          <div className="mymatches-list">
            {renderMatchesList()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mymatches;

